module.exports = __webpack_public_path__ + "img/team.24d7e44d.jpeg";